import { Color } from 'components/styles'
import { SummaryLevelEnum } from 'generated/api'
import { colors } from 'parameters/ui'
import { ApprovabilityIcons } from './assets'

interface ColoredPercentage {
	percentage: number
	color: Color
}
export const ApprovabilitySummaryLevelMap: Record<SummaryLevelEnum, ColoredPercentage> = {
	HIGH: { color: new Color(colors.creditScoreExcellent), percentage: 0.8 },
	LOW: { color: new Color(colors.creditScorePoor), percentage: 0.2 },
	MEDIUM: { color: new Color(colors.creditScoreVeryGood), percentage: 0.6 },
	PREAPPROVED: { color: new Color(colors.creditScoreExcellent), percentage: 1 },
	UNKNOWN: { color: new Color(colors.secondaryDarkGrey1), percentage: 0 }
}

export const ApprovabilityCopy = {
	Introduction: "This tool shows how how confident we are that you'll be approved for a loan by our partners. ",
	Help: {
		title: 'How it Works',
		intro:
			"Approvability is a score - Low, Medium, or High - which represents the likelihood that you’ll be offered a loan through our network. It's easy, fast and free.",
		steps: [
			{
				title: 'Your Details',
				body: "The more information, the more accurate your Approvability scores. Based on your inputs, we'll look at similar applications and their ultimate approval decisions from our network, which we use to calculate your approvability.",
				image: <ApprovabilityIcons.AboutYourself />
			},
			{
				title: 'Your Results',
				body: "We show you your approvability as a colored gauge next to each lender on our network. The color indicates how confident we are that you'll receive offers: Red for low, Blue for medium, or Green for high confidence. ",
				image: <ApprovabilityIcons.GetYourScore />
			}
		],
		facts: [
			{
				title: 'What is Approvability?',
				body: " Approvability is a score - Low, Medium, or High - which represents the likelihood that you’ll be approved for a loan by our network. It's calculated using applications similar to the information you provide that we've seen get approved recently, data we collect from our network, and overall market conditions"
			},
			{
				title: 'Approvability is not a guaranteed offer',
				body: "Until you submit an application, we can't know for sure if you'll be approved for a loan offer. There are many factors that go into evaluating an application, and our lending partners have the final say on whether or not to offer you a loan. "
			},
			{
				title: 'One Gauge - Many Approvabilities ',
				body: "The loan details and lending partners you're interested in matter. That's why we show you your Approvability per lender as well as total Approvability across our network, and let you provide details about the purpose and amount you're looking for."
			}
		],
		Closing:
			"Until you submit an application, you can't know for sure if you'll actually be approved for a loan offer. That's why we've made it fast, free and no risk to your credit to apply to dozens of lenders on Fiona.   "
	},
	hook: [
		'Put your approvability to the test and explore personalized offers.',
		" Its fast, free, and won't affect your credit."
	],
	Legal:
		'Your Approvability is only an estimate based on available approval data and does not guarantee approval or qualification for the advertised rates, fees, or terms presented. Other details, terms or APRs may change. Engine by MoneyLion calculates approval odds by using your own inputs compared with other factors such as aggregated historical and approval data for this product. Odds determined are only guidelines as any final decision by a provider is based on their own multi factor calculation as each person’s credit situation is unique.'
}
